import { AspObject, AspObjectSubscriber } from './AspObject';
import { IObjectsDrawer } from './interfaces';

export abstract class DisplayObject extends NeWMI.Object.NeWMIObjectDM implements AspObjectSubscriber {

  isDisplayed: boolean = false; // TRUE if added to NeWMI Draw Manager

  constructor(protected aspObject: AspObject, protected drawer: IObjectsDrawer) {
    super({ selected: false });

    this.id = aspObject.id;
    this.geometry = null;

    let is3D = drawer.is3D();
    this.drawData[aspObject.objectType] =
      drawer.drawUsingTemplate() ?
        (is3D && drawer.drawUsing3DModel() ? new NeWMI.Object.NeWMIObjectDM.Model3DDrawData() : new NeWMI.Object.NeWMIObjectDM.TemplateDrawData()) :
        this.createGeometryDrawData();

    this.aspObject.addSubscriber(this);
  }

  public getAspObject(): AspObject {
    return this.aspObject;
  }

  public getPresentationPoint() {
    return this.getDrawDataGeometry(this.aspObject.objectType).getPresentationPoint();
  }

  // Update of drawn item due to data update
  protected updateDrawValues() {
  }

  isVisible() {
    return this.drawer.isLayerVisible();
  }

  // Prepare object before draw
  protected prepareToDraw() {
  }

  // Override AspSubscriber
  onDataChange(): void {
    if (this.aspObject.geometry) {
      this.geometry = this.aspObject.geometry;

      if (this.drawData[this.aspObject.objectType].kind == NeWMI.Draw.DrawMgr.Enums.EKinds.Template) {
        this.drawData[this.aspObject.objectType].location = this.geometry;
      }
      this.updateDrawValues();

      this.boundsRect = this.geometry && this.geometry.getEnvelope().getRect();

      this.geometry.dataChanged();
    }
  }

  // Override AspSubscriber
  onHooked(hooked: boolean): void {
    let index = this.hookedTemplateIndex();
    if (index != -1 && this.canBeHooked()) {
      let isHooked = this.drawData[this.aspObject.objectType].values[index] != null;
      if (isHooked != hooked) {
        this.drawData[this.aspObject.objectType].values[index] = hooked ? ['hook-circle'] : null;
        this.drawer.updateObjectInDm(this);
      }
    }
  }

  // Override AspSubscriber
  onTrailVisibility(visible: boolean): void { }

  // Return index of hooked draw data element in object template
  protected hookedTemplateIndex(): number {
    return -1;
  }

  protected canBeHooked(): boolean {
    return true;
  }

  // Return draw data according to 3D/2D mode
  protected createGeometryDrawData(geometry?, lineWidth?, color?, fillcolor?) {
    let drawData: any;
    drawData = new NeWMI.Object.NeWMIObjectDM.GeometryDrawData();
    if (geometry)
      drawData.geometry = geometry;
    if (lineWidth && color)
      drawData.line = { width: lineWidth, color: color };
    else if (lineWidth)
      drawData.line = { width: lineWidth };
    else if (color)
      drawData.line = { color: color };
    if (fillcolor) {
      drawData.fill = { color: fillcolor };
    }
    return drawData;
  }

  // Set geometry draw data color according to 3D/2D mode
  protected setGeometryDrawDataColor(drawData: any, color: any[]) {
    if (this.drawer.is3D())
      drawData.color = color;
    else
      drawData.line.color = color;
  }
}
